export default "__VITE_ASSET__DFABOJ9j__"